import { NAVIGATION } from './config/navigation.js';
import { AppLayout } from './components/layout/AppLayout.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { DomainPage } from './pages/DomainPage.js';
import { NotFoundPage } from './pages/NotFoundPage.js';
import { PresidencyPage } from './pages/PresidencyPage.js';
import { InstitutionsPage } from './pages/InstitutionsPage.js';
import { GovernmentPage } from './pages/GovernmentPage.js';
import { EconomyPage } from './pages/EconomyPage.js';
import { UnitedStatesPage } from './pages/UnitedStatesPage.js';
import { EnterprisesPage } from './pages/EnterprisesPage.js';
import { InfrastructurePage } from './pages/InfrastructurePage.js';
import { SocietyPage } from './pages/SocietyPage.js';
import { JusticeSecurityPage } from './pages/JusticeSecurityPage.js';
import { WorldPage } from './pages/WorldPage.js';
import { StrategicPowerPage } from './pages/StrategicPowerPage.js';
import { DefensePage } from './pages/DefensePage.js';
import { CrisisPage } from './pages/CrisisPage.js';
import { SetupPage } from './pages/SetupPage.js';
import { OpinionPoliticsPage } from './pages/OpinionPoliticsPage.js';
import { DataPage } from './pages/DataPage.js';
import { useGame } from './state/GameContext.js';
import { useRouter } from './state/RouterContext.js';

export const App = () => {
  const { state } = useGame();
  const { path } = useRouter();
  if (!state.presidential.profile.configured) return <SetupPage />;
  const pathname = path.split('?')[0];
  const known = NAVIGATION.some((section) => pathname === section.path || pathname.startsWith(`${section.path}/`));
  let page = <NotFoundPage />;
  if (pathname === '/') page = <DashboardPage />;
  else if (pathname === '/presidence' || pathname.startsWith('/presidence/')) page = <PresidencyPage />;
  else if (pathname === '/institutions' || pathname.startsWith('/institutions/')) page = <InstitutionsPage />;
  else if (pathname === '/gouvernement' || pathname.startsWith('/gouvernement/')) page = <GovernmentPage />;
  else if (pathname === '/economie' || pathname.startsWith('/economie/')) page = <EconomyPage />;
  else if (pathname === '/etats-unis' || pathname.startsWith('/etats-unis/')) page = <UnitedStatesPage />;
  else if (pathname === '/entreprises' || pathname.startsWith('/entreprises/')) page = <EnterprisesPage />;
  else if (pathname === '/infrastructures' || pathname.startsWith('/infrastructures/')) page = <InfrastructurePage />;
  else if (pathname === '/societe' || pathname.startsWith('/societe/')) page = <SocietyPage />;
  else if (pathname === '/justice-securite' || pathname.startsWith('/justice-securite/')) page = <JusticeSecurityPage />;
  else if (pathname === '/monde' || pathname.startsWith('/monde/')) page = <WorldPage />;
  else if (pathname === '/defense' || pathname.startsWith('/defense/')) page = <DefensePage />;
  else if (pathname === '/crises' || pathname.startsWith('/crises/')) page = <CrisisPage />;
  else if (pathname === '/puissance' || pathname.startsWith('/puissance/')) page = <StrategicPowerPage />;
  else if (pathname === '/opinion' || pathname.startsWith('/opinion/')) page = <OpinionPoliticsPage />;
  else if (pathname === '/donnees' || pathname.startsWith('/donnees/')) page = <DataPage />;
  else if (known) page = <DomainPage />;
  return <AppLayout>{page}</AppLayout>;
};
